export default {
    type: 'panel',
    name: 'exitIntent',
    blocks: [
        {
            name: 'promo',
            label: 'Promotion',
            type: 'mixed',
            max: 2,
            blocks: [
                {
                    name: 'content',
                    label: 'Contenu',
                    type: 'html',
                    max: 1,
                },
                {
                    name: 'code',
                    label: 'Code promo',
                    type: 'text',
                    max: 1,
                },
            ],
        },
        {
            name: 'extra',
            label: 'Infos supplémentaires',
            max: 1,
            type: 'html',
        },
    ],
};
